<template>
  <div v-if="posts"> 
    
    <table class="table-eco">
      <thead>
        <tr>
          <template v-for="field in fields_list">
            
            <th v-if="field=='title'">Title</th>
            <th v-if="field=='client'">Kunde</th>
            <th v-if="field=='project'">Opgave</th>
            <th v-if="field=='paydate'">Betalingsdato</th>
            <th v-if="field=='invoice_no'">Faktura #</th>
            <th v-if="field=='invoice_date'">Fakturadato</th>
            <th v-if="field=='invoiced'">Faktureret</th>
            <th v-if="field=='paid'">Betalt</th>
            <th v-if="field=='amount'" class="align-r">Kr. ex. moms</th>

          </template>          
        </tr>
      </thead>
      <tbody>
        <tr v-for="(post,i) in posts" :class="negaPosi_cls(post.amount_dkk_ex_vat)">

          <template v-for="field in fields_list">

            <td v-if="field=='title'">
              <div class="textlink" @click="openEconomypost(post)">
                {{economypostTitle(post) || '?'}}
              </div>              
            </td>
            <td v-if="field=='project'">
              <div class="textlink" @click="openEconomypost(post)">
                <template v-if="post.project_key">
                  {{projects[post.project_key].name}}
                </template>
                <template v-else>
                  &mdash;
                </template>
              </div>
            </td>
            <td v-if="field=='client'">
              <div class="textlink" @click="openEconomypost(post)">
                <template v-if="post.client_key">
                  {{clients[post.client_key].name}}
                </template>
                <template v-else>
                  &mdash;
                </template>
              </div>              
            </td>
            <td v-if="field=='invoice_date'">
              <div class="textlink" @click="openEconomypost(post)">
                {{post.invoice_date || '?'}}
              </div>                          
            </td>
            <td v-if="field=='paydatet'">
              <div class="textlink" @click="openEconomypost(post)">
                {{post.payment_due_date || '?'}}
              </div>                          
            </td>
            <td v-if="field=='invoice_no'">
              <div class="textlink" @click="openEconomypost(post)">
                {{post.invoice_no || '?'}}
              </div>                          
            </td>
            <td v-if="field=='invoiced'">
              <svgicon v-if="post.invoiced" icon="ionicons/checkmark"></svgicon><template v-else>&mdash;</template>
            </td>
            <td v-if="field=='paid'">
              <svgicon v-if="post.paid" icon="ionicons/checkmark"></svgicon><template v-else>&mdash;</template>
            </td>          
            <td v-if="field=='amount'">
              <div class="textlink" @click="openEconomypost(post)">
                {{ post.amount_dkk_ex_vat | money(0) }}
              </div>              
            </td>

          </template>   

        </tr>
        <tr v-if="totals" class="spacer"><td :colspan="colcount"></td></tr>
      </tbody>
      <tfoot v-if="totals">
        <tr>
          <td :colspan="colcount-2"></td>
          <td class="">Indtægter</td>
          <td class="align-r posi">
            {{ totals.income_total | money(0) }}
          </td>
        </tr>
        <tr>
          <td :colspan="colcount-2"></td>
          <td class="">Udgifter</td>
          <td class="nega">
            {{ totals.expense_total | money(0)  }}
          </td>
        </tr>
        <tr class="spacer"><td :colspan="colcount"></td></tr>
        <tr>
          <td :colspan="colcount-2"></td>
          <td class=""><b>Total</b></td>
          <td :class="negaPosi_cls(totals.total)">
            <b>{{ totals.total | money(0) }}</b>
          </td>
        </tr>
      </tfoot>
    </table>

  </div>
</template>

<script>
import helpers from '.././helpers.js';
import fdb from '.././firebase_config.js';
import mixins from '.././mixins.js';
import moment from 'moment'
import Avatar from '.././components/Avatar'
import Btn from '.././components/Btn'
export default {
  components: { Avatar, Btn, },
  mixins: [ mixins.db, mixins.generic ],
  props: {
    posts: { type:Array },
    totals: { type:Object },
    fields: { type:String, default:'client,project,invoice_no,invoice_date,invoiced,paid,amount' },
  },
  data(){ return {    
  } },
  computed: {
    
    economyposts(){ return this.$store.state.firebase.economyposts },
    clients(){ return this.$store.state.firebase.clients },
    projects(){ return this.$store.state.firebase.projects },

    colcount(){
      return this.fields_list.length
    },

    fields_list(){ return this.fields.split(',') },

  },
  methods: {

    show_field(key){ return (this.fields && this.fields.indexOf(key) !== -1 ) },

    outputMoney: helpers.outputMoney,
    
    economypostTitle(economypost){
      var t = '-'
      if( economypost.title && economypost.title.length ) t = economypost.title
      if( economypost.project_key ) t = this.$store.state.firebase.projects[economypost.project_key].name
      if( economypost.hypothetic ) t = 'Hypotetisk: ' + t
      return t
    },

    negaPosi_cls(input){
      var cls = ''
      if( input > 0 ) cls += ' posi '
      if( input < 0 ) cls += ' nega '      
      return cls
    },

    openEconomypost(economypost){
      globals.modal_economypost_edit.economypost = economypost
      globals.modal_economypost_edit.active = true      
    },

  },
}
</script>



// WEBPACK FOOTER //
// EconomyPosts.vue?630fd5c6